import { atom } from 'recoil';
let lguIOSWarning = atom<any>({
  key: 'lguIOSWarning',
  default: {
    showLguIosWarning: false,
    message: "대출비교 서비스 점검 중입니다. (~5/20)<br>이용에 불편을 드려 죄송합니다.",
    confirmText: "확인",
  }
});

export { lguIOSWarning };